<div class="content" style="padding-bottom: 100px;">
    <app-header [entregador]="entregador" [historico_entregador]="true" [isOnline]="isOnline" [logado]="true"></app-header>
    <div style="margin-left:3%;">
        <app-historico-card [historico]="historico" [rotas]="rotas" [pedidos]="pedidos" [tipo]="'entregador'"></app-historico-card>

    </div>
    <label class="nenhum_pedido" *ngIf="!pedidos">Nenhum pedido encontrado</label>
    <app-footer-logado></app-footer-logado>
    
</div>